import { render, staticRenderFns } from "./BranchTraderWiseConcSettingModal.vue?vue&type=template&id=db520798&"
import script from "./BranchTraderWiseConcSettingModal.vue?vue&type=script&lang=js&"
export * from "./BranchTraderWiseConcSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports